import { Tokens } from "../../interfaces/token";
import Cookies from "js-cookie";

export const authToken = {
    key: "ABREHAMRAHI_AUTH_TOKEN",
    get: function (): Tokens | null {
        let data;
        data = Cookies.get(authToken.key);
        if (data) return JSON.parse(data);
        return null;
    },
    set: (value: Tokens) => {
        Cookies.set(authToken.key, JSON.stringify(value), { expires: 1095 });
    },
    remove: () => {
        Cookies.remove(authToken.key);
    }
};

export const captchaStorageLogin = {
    key: "ABREHAMRAHI_DRIVE_AUTH_CAPTCHA",
    get: function (): string | null {
        const data = localStorage.getItem(captchaStorageLogin.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: string) => {
        localStorage.setItem(captchaStorageLogin.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(captchaStorageLogin.key);
    }
};

export const captchaStorageCode = {
    key: "ABREHAMRAHI_DRIVE_CODE_CAPTCHA",
    get: function (): string | null {
        const data = localStorage.getItem(captchaStorageCode.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: string) => {
        localStorage.setItem(captchaStorageCode.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(captchaStorageCode.key);
    }
};

export const captchaStorageCodeNewPhoneWhenChangePhone = {
    key: "ABREHAMRAHI_DRIVE_CODE_CAPTCHA_NEW_PHONE",
    get: function (): string | null {
        const data = localStorage.getItem(captchaStorageCodeNewPhoneWhenChangePhone.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: string) => {
        localStorage.setItem(captchaStorageCodeNewPhoneWhenChangePhone.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(captchaStorageCodeNewPhoneWhenChangePhone.key);
    }
};

export const planVoucherCaptchaStorageCode = {
    key: "HAMRAHI_CLOUD_PLAN_VOUCHER_CAPTCHA",
    get: function (): string | null {
        const data = localStorage.getItem(planVoucherCaptchaStorageCode.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: string) => {
        localStorage.setItem(planVoucherCaptchaStorageCode.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(planVoucherCaptchaStorageCode.key);
    }
};

export const planActiveVoucherCaptchaStorageCode = {
    key: "HAMRAHI_CLOUD_PLAN_ACTIVE_VOUCHER_CAPTCHA",
    get: function (): string | null {
        const data = localStorage.getItem(planActiveVoucherCaptchaStorageCode.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: string) => {
        localStorage.setItem(planActiveVoucherCaptchaStorageCode.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(planActiveVoucherCaptchaStorageCode.key);
    }
};
